import { Controller } from "@hotwired/stimulus"

// Refresh the nav chip whenever any alert-section frame re-renders
document.addEventListener("turbo:frame-render", (event) => {
  if (!event.target.id?.startsWith("alert-section-")) return
  const chip = document.querySelector("turbo-frame#nav-alert-chip")
  if (!chip) return
  if (chip.src) {
    chip.reload()
  } else {
    chip.setAttribute("src", chip.dataset.src)
  }
})

export default class extends Controller {
  static targets = ["bulkBar", "bulkCount", "confirmPopover"]
  static values  = { section: String }

  // Called whenever a checkbox changes
  onCheck(event) {
    this.#toggleRowEmailInputs(event.target, event.target.checked)
    this.#updateBulkBar()
  }

  // "Select all" button
  selectAll() {
    this.#checkboxes().forEach(cb => {
      cb.checked = true
      this.#toggleRowEmailInputs(cb, true)
    })
    this.#updateBulkBar()
  }

  // Show the confirmation popover instead of submitting directly
  requestConfirm() {
    if (this.#selectedCount() === 0) return
    if (!this.hasConfirmPopoverTarget) return
    this.confirmPopoverTarget.classList.remove("hidden")
  }

  // Cancel — hide the popover, leave selections intact
  cancelConfirm() {
    this.confirmPopoverTarget.classList.add("hidden")
  }

  // Confirmed — submit the form and hide the popover
  confirmSubmit() {
    this.confirmPopoverTarget.classList.add("hidden")
    document.getElementById(`dismiss-form-${this.sectionValue}`).requestSubmit()
  }

  // ── private ──────────────────────────────────────────────────

  // Enable/disable hidden email_ids[] inputs for a given row checkbox.
  // Rows that don't use this pattern (warranties, insurance) have no
  // matching hidden inputs, so this is a no-op for them.
  #toggleRowEmailInputs(checkbox, enabled) {
    const rowId = checkbox.dataset.dashboardAlertsRowParam
    if (!rowId) return
    const row = document.getElementById(rowId)
    if (!row) return
    row.querySelectorAll('input[type=hidden][name="email_ids[]"]').forEach(input => {
      input.disabled = !enabled
    })
  }

  #checkboxes() {
    return Array.from(this.element.querySelectorAll("input[type=checkbox]"))
  }

  #selectedCount() {
    return this.#checkboxes().filter(cb => cb.checked).length
  }

  #updateBulkBar() {
    const count = this.#selectedCount()

    if (count > 0) {
      this.bulkBarTarget.classList.remove("hidden")
      this.bulkBarTarget.classList.add("flex")
      this.bulkCountTarget.textContent = `${count} selected`
    } else {
      this.bulkBarTarget.classList.add("hidden")
      this.bulkBarTarget.classList.remove("flex")
    }
  }
}
